import { render } from "./MvLogo.vue?vue&type=template&id=ca494192&scoped=true"
const script = {}

import "./MvLogo.vue?vue&type=style&index=0&id=ca494192&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca494192"]])

export default __exports__